/* HDD · Entrada «tormenta de licoris» (higanbana) y pétalos que flotan en la portada.
 *
 * Arte original dibujado por código, sin imágenes: cada flor de Lycoris radiata se construye en 3D
 * (5–7 florecillas, seis pétalos estrechos muy rizados hacia atrás y estambres larguísimos) y se
 * proyecta desde un ángulo distinto, con sombreado plano de dos tonos y línea fina, estilo anime.
 *
 * Secuencia: la tormenta gira alrededor del logo, una ráfaga se la lleva, la pantalla se abre desde el
 * centro y, mientras las flores salen volando, aparecen los kimonos (evento «hdd:intro-done»).
 * Después quedan unos pocos pétalos en el héroe que se apartan con el ratón y suben con el scroll.
 *
 * Respeta «reducir movimiento», se puede saltar (botón, tecla, rueda o toque) y solo se ve una vez por
 * sesión. Si este archivo no carga, el CSS de la sección retira la capa por sí solo.
 */
(() => {
  'use strict';
  const TAU = Math.PI * 2;
  const doc = document.documentElement;
  const intro = document.querySelector('[data-hs-intro]');
  const hero = document.querySelector('[data-hs-hero]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- utilidades
  const clamp = (x, a, b) => (x < a ? a : x > b ? b : x);
  const lerp = (a, b, t) => a + (b - a) * t;
  const smooth = (e0, e1, x) => { const t = clamp((x - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  function rng(seed) {
    let s = (seed >>> 0) || 1;
    return () => ((s = (Math.imul(s, 1664525) + 1013904223) >>> 0) / 4294967296);
  }
  const V = (x, y, z) => ({ x, y, z });
  const add = (a, b) => V(a.x + b.x, a.y + b.y, a.z + b.z);
  const mul = (a, k) => V(a.x * k, a.y * k, a.z * k);
  const dot = (a, b) => a.x * b.x + a.y * b.y + a.z * b.z;
  const cross = (a, b) => V(a.y * b.z - a.z * b.y, a.z * b.x - a.x * b.z, a.x * b.y - a.y * b.x);
  const norm = (a) => { const l = Math.hypot(a.x, a.y, a.z) || 1; return V(a.x / l, a.y / l, a.z / l); };
  function rotMat(yaw, pitch, roll) {
    const cy = Math.cos(yaw), sy = Math.sin(yaw), cp = Math.cos(pitch), sp = Math.sin(pitch), cr = Math.cos(roll), sr = Math.sin(roll);
    // R = Rz(roll) · Rx(pitch) · Ry(yaw)
    const ry = [[cy, 0, sy], [0, 1, 0], [-sy, 0, cy]];
    const rx = [[1, 0, 0], [0, cp, -sp], [0, sp, cp]];
    const rz = [[cr, -sr, 0], [sr, cr, 0], [0, 0, 1]];
    const m = (A, B) => A.map((r) => [0, 1, 2].map((j) => r[0] * B[0][j] + r[1] * B[1][j] + r[2] * B[2][j]));
    return m(rz, m(rx, ry));
  }
  const ap = (M, p) => V(M[0][0] * p.x + M[0][1] * p.y + M[0][2] * p.z, M[1][0] * p.x + M[1][1] * p.y + M[1][2] * p.z, M[2][0] * p.x + M[2][1] * p.y + M[2][2] * p.z);

  // ---------- la flor en 3D
  const RED = '#d1121f', RED_SH = '#8a0714', RED_HI = '#ff6a5c', INK = '#4a020a', STAMEN = '#e3192b', ANTHER = '#5c0a0e';

  function floret(rand, a, tepals, stamens, k0) {
    // marco local de la florecilla
    let up = Math.abs(a.z) < 0.95 ? V(0, 0, 1) : V(1, 0, 0);
    const u = norm(cross(a, up)), v = norm(cross(a, u));
    const base = mul(a, 0.07 + rand() * 0.03);
    const L = 0.56 + rand() * 0.1;
    for (let k = 0; k < 6; k++) {
      const psi = (TAU * k) / 6 + (rand() - 0.5) * 0.35 + k0;
      const r = add(mul(u, Math.cos(psi)), mul(v, Math.sin(psi)));
      const n = norm(cross(a, r));                       // el ancho del pétalo va perpendicular al rizo
      const a0 = 0.5 + rand() * 0.25, curl = 2.15 + rand() * 0.5, N = 30, W = 0.06 + rand() * 0.02;
      let p = base;
      const pts = [], dirs = [], wid = [];
      for (let i = 0; i <= N; i++) {
        const s = i / N;
        const al = a0 + curl * Math.pow(s, 1.35);
        const d = norm(add(mul(a, Math.cos(al)), mul(r, Math.sin(al))));
        pts.push(p); dirs.push(d);
        wid.push(W * Math.pow(Math.sin(Math.PI * Math.min(1, s * 1.04 + 0.03)), 0.6) * (1 + 0.16 * Math.sin(s * 17 + k * 1.7)));
        p = add(p, mul(d, L / N));
      }
      tepals.push({ pts, dirs, n, wid });
    }
    for (let j = 0; j < 7; j++) {
      const psi = (TAU * j) / 7 + rand() * 0.4 + 0.3;
      const r = add(mul(u, Math.cos(psi)), mul(v, Math.sin(psi)));
      const c0 = norm(add(mul(a, 0.8), mul(r, 0.42 + rand() * 0.2)));
      const len = 0.88 + rand() * 0.22, N = 14;
      const pts = [];
      let p = add(base, mul(a, 0.02));
      for (let i = 0; i <= N; i++) {
        const s = i / N;
        // se curvan hacia arriba (hacia el eje del tallo) y abren la punta
        const d = norm(add(mul(c0, 1 - 0.75 * Math.pow(s, 1.6)), mul(V(0, 0, 1), 0.75 * Math.pow(s, 1.6))));
        pts.push(p);
        p = add(p, mul(d, len / N));
      }
      stamens.push({ pts, style: j === 6 });
    }
  }

  function flowerModel(seed) {
    const rand = rng(seed);
    const n = 5 + Math.floor(rand() * 3);
    const tepals = [], stamens = [];
    for (let i = 0; i < n; i++) {
      const phi = (TAU * i) / n + (rand() - 0.5) * 0.5;
      const th = 0.95 + rand() * 0.35;
      floret(rand, V(Math.sin(th) * Math.cos(phi), Math.sin(th) * Math.sin(phi), Math.cos(th)), tepals, stamens, rand());
    }
    return { tepals, stamens };
  }

  function petalModel(seed) {
    const rand = rng(seed);
    const tepals = [];
    floret(rand, V(0, 0, 1), tepals, [], 0);
    return { tepals: [tepals[Math.floor(rand() * 6)]], stamens: [] };
  }

  /** dibuja un modelo en un lienzo cuadrado de lado S (con la orientación dada) */
  function paint(model, S, yaw, pitch, roll, glow) {
    const c = document.createElement('canvas');
    c.width = c.height = S;
    const g = c.getContext('2d');
    const M = rotMat(yaw, pitch, roll);
    // encuadre automático: la flor (o el pétalo) llena el lienzo con un pequeño margen
    let x0 = Infinity, x1 = -Infinity, y0 = Infinity, y1 = -Infinity;
    const all = [];
    model.tepals.forEach((t) => t.pts.forEach((q) => all.push(q)));
    model.stamens.forEach((st) => st.pts.forEach((q) => all.push(q)));
    all.forEach((q) => { const r = ap(M, q); x0 = Math.min(x0, r.x); x1 = Math.max(x1, r.x); y0 = Math.min(y0, r.y); y1 = Math.max(y1, r.y); });
    const span = Math.max(x1 - x0, y1 - y0) || 1;
    const scale = (S * 0.86) / span, cx = S / 2 - ((x0 + x1) / 2) * scale, cy = S / 2 + ((y0 + y1) / 2) * scale;
    const P = (q) => { const r = ap(M, q); return { x: cx + r.x * scale, y: cy - r.y * scale, z: r.z }; };
    const Ld = norm(V(-0.45, 0.6, 0.75));
    const prims = [];
    model.tepals.forEach((t) => {
      const n = ap(M, t.n);
      const L = [], R = [], tone = [];
      let zs = 0;
      t.pts.forEach((q, i) => {
        const off = mul(t.n, t.wid[i]);
        L.push(P(add(q, off))); R.push(P(add(q, mul(off, -1))));
        const d = ap(M, t.dirs[i]);
        const nn = norm(cross(d, n));
        const lam = Math.abs(dot(nn, Ld));
        tone.push(lam);
        zs += ap(M, q).z;
      });
      prims.push({ kind: 't', L, R, tone, z: zs / t.pts.length });
    });
    model.stamens.forEach((s) => {
      const pts = s.pts.map(P);
      prims.push({ kind: 's', pts, style: s.style, z: pts.reduce((a, p) => a + p.z, 0) / pts.length + 0.02 });
    });
    prims.sort((a, b) => a.z - b.z);
    const draw = () => {
      prims.forEach((pr) => {
        if (pr.kind === 't') {
          const { L, R, tone } = pr;
          // cuerpo del pétalo: tramos con dos tonos (plano, como en el anime)
          for (let i = 0; i < L.length - 1; i++) {
            g.beginPath();
            g.moveTo(L[i].x, L[i].y); g.lineTo(L[i + 1].x, L[i + 1].y); g.lineTo(R[i + 1].x, R[i + 1].y); g.lineTo(R[i].x, R[i].y);
            g.closePath();
            const t = (tone[i] + tone[i + 1]) / 2;
            g.fillStyle = t > 0.42 ? RED : RED_SH;
            g.fill();
            g.strokeStyle = g.fillStyle; g.lineWidth = 0.6; g.stroke();
          }
          // contorno fino
          g.beginPath();
          g.moveTo(L[0].x, L[0].y);
          for (let i = 1; i < L.length; i++) g.lineTo(L[i].x, L[i].y);
          for (let i = R.length - 1; i >= 0; i--) g.lineTo(R[i].x, R[i].y);
          g.closePath();
          g.strokeStyle = INK; g.lineWidth = Math.max(0.7, scale / 140); g.globalAlpha = 0.85; g.stroke(); g.globalAlpha = 1;
          // brillo: trazo claro en la parte iluminada
          g.beginPath();
          let on = false;
          for (let i = 2; i < L.length - 3; i++) {
            const mx = (L[i].x + R[i].x) / 2, my = (L[i].y + R[i].y) / 2;
            if (tone[i] > 0.62) { if (!on) { g.moveTo(mx, my); on = true; } else g.lineTo(mx, my); } else on = false;
          }
          g.strokeStyle = RED_HI; g.lineWidth = Math.max(0.8, scale / 95); g.globalAlpha = 0.75; g.stroke(); g.globalAlpha = 1;
        } else {
          const p = pr.pts;
          for (let i = 0; i < p.length - 1; i++) {
            const s = i / (p.length - 1);
            g.beginPath(); g.moveTo(p[i].x, p[i].y); g.lineTo(p[i + 1].x, p[i + 1].y);
            g.strokeStyle = pr.style ? '#f0303c' : STAMEN;
            g.lineWidth = Math.max(0.7, (scale / 80) * (1.25 - 0.55 * s));
            g.lineCap = 'round';
            g.stroke();
          }
          const e = p[p.length - 1];
          g.beginPath(); g.ellipse(e.x, e.y, scale / 42, scale / 66, Math.atan2(e.y - p[p.length - 3].y, e.x - p[p.length - 3].x), 0, TAU);
          g.fillStyle = pr.style ? '#ff7b6e' : ANTHER; g.fill();
        }
      });
    };
    if (glow) {
      g.save(); g.shadowColor = 'rgba(255,24,40,0.55)'; g.shadowBlur = S / 14; draw(); g.restore();
    }
    draw();
    return c;
  }

  /** desenfoque barato (sirve en todos los navegadores): reducir y volver a ampliar */
  function blurred(src, k) {
    const s = Math.max(8, Math.round(src.width / k));
    const a = document.createElement('canvas'); a.width = a.height = s;
    const ga = a.getContext('2d'); ga.imageSmoothingQuality = 'high'; ga.drawImage(src, 0, 0, s, s);
    const b = document.createElement('canvas'); b.width = b.height = src.width;
    const gb = b.getContext('2d'); gb.imageSmoothingQuality = 'high'; gb.drawImage(a, 0, 0, src.width, src.height);
    return b;
  }

  function makeSprites(big) {
    const S = big ? 300 : 220;
    const flowers = [], petals = [];
    const views = [[0.2, 0.05, 0], [0.9, 0.35, 1.2], [-0.4, 1.05, 2.4], [1.8, 0.7, 4.1], [0.1, 1.35, 0.6], [2.6, 0.2, 3.3], [-1.2, 0.9, 5.2], [0.5, -0.5, 1.9]];
    views.forEach((vw, i) => {
      const m = flowerModel(101 + i * 37);
      const sharp = paint(m, S, vw[0], vw[1], vw[2], i % 3 === 0);
      flowers.push({ sharp, soft: blurred(sharp, 5), far: blurred(sharp, 3) });
    });
    for (let i = 0; i < 6; i++) {
      const m = petalModel(900 + i * 13);
      const sharp = paint(m, 96, i * 1.1, 0.5 + i * 0.4, i, false);
      petals.push({ sharp, soft: blurred(sharp, 4), far: sharp });
    }
    return { flowers, petals };
  }

  // ---------- partículas
  function particle(kind, W, H, rand, z, x, y) {
    return {
      kind, x, y, z,
      vx: 0, vy: 0,
      a: rand() * TAU, spin: (rand() - 0.5) * (kind === 'f' ? 2.2 : 5),
      flip: rand() * TAU, flipV: 2 + rand() * 4,
      i: Math.floor(rand() * (kind === 'f' ? 8 : 6)),
      size: kind === 'f' ? 70 + rand() * 70 : 20 + rand() * 18,
      drag: kind === 'f' ? 1.6 + rand() * 0.6 : 3 + rand() * 1.5,
      life: 0,
    };
  }

  function drawP(g, sp, p, alpha) {
    const set = p.kind === 'f' ? sp.flowers[p.i % sp.flowers.length] : sp.petals[p.i % sp.petals.length];
    const img = p.z > 1.3 ? set.soft : p.z < 0.6 ? set.far : set.sharp;
    const s = p.size * p.z;
    const fx = p.kind === 'p' ? Math.cos(p.flip) : 1;
    const c = Math.cos(p.a), si = Math.sin(p.a);
    g.globalAlpha = alpha * (p.z < 0.6 ? 0.55 + p.z * 0.4 : 1);
    g.setTransform(c * fx, si * fx, -si, c, p.x, p.y);
    g.drawImage(img, -s / 2, -s / 2, s, s);
  }

  // ---------- la tormenta de entrada
  function storm(sp) {
    intro.classList.add('is-running');
    doc.classList.add('hs-intro-running');
    const canvas = intro.querySelector('canvas');
    const mark = intro.querySelector('[data-hs-intro-mark]');
    const skipBtn = intro.querySelector('[data-hs-intro-skip]');
    const g = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    let W = 0, H = 0;
    const resize = () => {
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    };
    resize();
    window.addEventListener('resize', resize);
    const rand = rng(Date.now() & 0xffff);
    const area = W * H;
    // móvil: más flores y algo más pequeñas, para que también se lea como una tormenta en pantalla estrecha
    const small = Math.min(W, H) < 600;
    const maxF = Math.round(clamp(area / 11000, small ? 72 : 40, 120));
    const maxP = Math.round(clamp(area / 4200, small ? 170 : 90, 260));
    const parts = [];
    const spawn = (kind, inside) => {
      const z = kind === 'f' ? 0.45 + rand() * 1.15 : 0.4 + rand() * 1.3;
      let x, y;
      if (inside) {
        const ang = rand() * TAU, rr = (0.15 + rand() * 0.75) * Math.min(W, H) * 0.55;
        x = W * 0.5 + Math.cos(ang) * rr * 1.25; y = H * 0.47 + Math.sin(ang) * rr;
      } else if (rand() < 0.62) { x = -120 - rand() * 120; y = H * (0.15 + rand() * 0.95); } else { x = W * rand() * 0.8; y = H + 100 + rand() * 120; }
      const p = particle(kind, W, H, rand, z, x, y);
      if (small) p.size *= kind === 'f' ? 0.72 : 0.85;
      p.vx = 260 + rand() * 200; p.vy = -120 - rand() * 160;
      parts.push(p);
    };
    for (let i = 0; i < maxF * 0.35; i++) spawn('f', true);
    for (let i = 0; i < maxP * 0.35; i++) spawn('p', true);
    // unas pocas flores muy cerca de la «cámara» (grandes y desenfocadas) dan profundidad
    const nearN = Math.round(clamp(area / 120000, 4, 12));
    for (let i = 0; i < nearN; i++) {
      const p = particle('f', W, H, rand, 1.9 + rand() * 0.8, -200 - rand() * W * 0.6, H * (0.1 + rand() * 0.9));
      p.size = (120 + rand() * 60) * (small ? 0.7 : 1); p.vx = 300; p.vy = -60; p.near = true;
      parts.push(p);
    }

    let t = 0, last = performance.now(), done = false, sent = false, skipped = false;
    const GUST = 2.45, OPEN = 2.6, END = 4.3;
    const skip = () => { if (!skipped && t < GUST) { skipped = true; t = GUST; } };
    skipBtn && skipBtn.addEventListener('click', skip);
    ['wheel', 'touchstart', 'keydown'].forEach((ev) => window.addEventListener(ev, skip, { passive: true, once: true }));

    const finish = () => {
      if (done) return;
      done = true;
      intro.classList.add('is-gone');
      doc.classList.remove('hs-intro-on', 'hs-intro-running');
      window.removeEventListener('resize', resize);
      setTimeout(() => intro.remove(), 400);
    };
    const signal = () => {
      if (sent) return;
      sent = true;
      window.__hddIntroDone = true;
      window.dispatchEvent(new CustomEvent('hdd:intro-done'));
    };

    const fixedDt = window.__HDD_LYCORIS_FIXED_DT || 0;     // solo para pruebas automáticas
    function frame(now) {
      const dt = fixedDt || Math.min(0.05, (now - last) / 1000);
      last = now; t += dt;
      window.__hddIntroT = t;
      const S = smooth(0.0, 0.9, t) * (1 - smooth(GUST, GUST + 0.5, t));     // fuerza del remolino
      const G = smooth(GUST - 0.1, GUST + 0.7, t);                              // ráfaga final
      const cx = W * 0.5, cy = H * 0.47, R0 = Math.min(W, H) * 0.3;
      // nuevas flores mientras dura la tormenta
      if (t < GUST - 0.2) {
        const want = smooth(0, 1.2, t);
        if (parts.filter((p) => p.kind === 'f').length < maxF * want && rand() < 0.9) spawn('f', false);
        for (let k = 0; k < 3; k++) if (parts.filter((p) => p.kind === 'p').length < maxP * want) spawn('p', false);
      }
      // fondo: noche roja que se abre desde el centro
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.globalAlpha = 1;
      g.clearRect(0, 0, W, H);
      const open = smooth(OPEN, OPEN + 1.05, t);
      if (open < 1) {
        const diag = Math.hypot(W, H);
        const bg = g.createRadialGradient(cx, cy * 0.92, 0, cx, cy, diag * 0.62);
        bg.addColorStop(0, '#3a060c'); bg.addColorStop(0.45, '#16040a'); bg.addColorStop(1, '#050204');
        g.fillStyle = bg; g.fillRect(0, 0, W, H);
        // luna pálida detrás del logo
        const mr = Math.min(W, H) * 0.26;
        const moon = g.createRadialGradient(cx, cy, mr * 0.2, cx, cy, mr * 1.6);
        moon.addColorStop(0, 'rgba(255,214,200,0.16)'); moon.addColorStop(0.55, 'rgba(255,90,80,0.07)'); moon.addColorStop(1, 'rgba(255,40,40,0)');
        g.fillStyle = moon; g.fillRect(0, 0, W, H);
        if (open > 0) {
          g.globalCompositeOperation = 'destination-out';
          const r = open * diag * 0.75;
          const hole = g.createRadialGradient(cx, cy, Math.max(0, r - 220), cx, cy, r + 1);
          hole.addColorStop(0, 'rgba(0,0,0,1)'); hole.addColorStop(1, 'rgba(0,0,0,0)');
          g.fillStyle = hole; g.fillRect(0, 0, W, H);
          g.globalCompositeOperation = 'source-over';
        }
      }
      // líneas de viento en el momento fuerte
      const lines = S * (1 - G);
      if (lines > 0.05) {
        g.lineCap = 'round';
        for (let i = 0; i < 26; i++) {
          const ang = t * 2.4 + i * 0.97, rr = R0 * (0.7 + ((i * 37) % 11) / 8);
          const x = cx + Math.cos(ang) * rr * 1.3, y = cy + Math.sin(ang) * rr;
          const len = 40 + ((i * 53) % 90);
          g.globalAlpha = 0.07 + 0.12 * lines * ((i % 3) / 2);
          g.strokeStyle = i % 4 ? '#ffd8d0' : '#ff3b45';
          g.lineWidth = 1 + (i % 3) * 0.6;
          g.beginPath();
          g.arc(cx, cy, Math.hypot(x - cx, (y - cy) * 1.3) || 1, ang, ang + len / rr);
          g.stroke();
        }
      }
      // viento: remolino + deriva + ráfaga + turbulencia
      for (let i = parts.length - 1; i >= 0; i--) {
        const p = parts[i];
        const dx = p.x - cx, dy = (p.y - cy) * 1.25;
        const r = Math.hypot(dx, dy) || 1;
        const q = r / R0;
        const vt = (S * 1250 * q) / (1 + q * q);
        let wx = (-dy / r) * vt - (dx / r) * 160 * S + 320 * S;
        let wy = (dx / r) * vt - (dy / r) * 160 * S - 40 * S;
        wx += Math.sin(p.y * 0.006 + t * 1.7 + i) * 120 + G * (1500 + (dx / r) * 700);
        wy += Math.cos(p.x * 0.005 - t * 1.3) * 110 + G * (-820 + (dy / r) * 700);
        const k = 1 - Math.exp(-p.drag * dt);
        p.vx += (wx * (0.55 + p.z * 0.45) - p.vx) * k;
        p.vy += (wy * (0.55 + p.z * 0.45) - p.vy) * k;
        p.x += p.vx * dt; p.y += p.vy * dt;
        p.a += p.spin * dt * (1 + G * 2); p.flip += p.flipV * dt;
        p.life += dt;
        const m = 260;
        if (p.x > W + m || p.y < -m || p.y > H + m * 1.5 || p.x < -m * 2) {
          if (t < GUST - 0.3) { // durante la tormenta vuelven a entrar por la izquierda
            p.x = -100 - Math.random() * 80; p.y = H * (0.1 + Math.random() * 0.9); p.vx = 300; p.vy = -100;
          } else { parts.splice(i, 1); continue; }
        }
      }
      parts.sort((a, b) => a.z - b.z);
      const fadeIn = smooth(0, 0.35, t);
      for (const p of parts) drawP(g, sp, p, fadeIn);
      g.setTransform(1, 0, 0, 1, 0, 0); g.globalAlpha = 1;

      if (t > 0.35 && mark) mark.classList.add('is-in');
      if (t > GUST && mark) mark.classList.add('is-out');
      if (t > GUST + 0.35) signal();                     // los kimonos entran mientras las flores se van
      if (t > OPEN + 0.5) intro.classList.add('is-open');
      if (t >= END || (t > OPEN + 1.1 && !parts.length)) { signal(); finish(); return; }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame((n) => { last = n; frame(n); });
    // seguro: si algo va mal, nunca se queda tapando la tienda
    if (!fixedDt) setTimeout(() => { signal(); finish(); }, 9000);
  }

  // ---------- pétalos que se quedan en el héroe
  function ambient(sp) {
    if (!hero || reduce) return;
    const stage = hero.querySelector('.hs-hero__stage') || hero;
    const canvas = document.createElement('canvas');
    canvas.className = 'hs-petals';
    canvas.setAttribute('aria-hidden', 'true');
    const duo = stage.querySelector('.hs-duo');
    stage.insertBefore(canvas, duo || null);
    const g = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 1.75);
    let W = 1, H = 1;
    const rs = () => { const r = canvas.getBoundingClientRect(); W = Math.max(1, r.width); H = Math.max(1, r.height); canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr); };
    rs();
    new ResizeObserver(rs).observe(canvas);
    const rand = rng(77);
    const n = W < 600 ? 7 : 12;
    const ps = [];
    for (let i = 0; i < n; i++) {
      const p = particle(i < 2 ? 'f' : 'p', W, H, rand, 0.55 + rand() * 0.8, rand() * W, rand() * H);
      if (p.kind === 'f') p.size = 46 + rand() * 20;
      p.base = 0.25 + rand() * 0.35;
      ps.push(p);
    }
    let mx = -9999, my = -9999, lastY = window.scrollY, lift = 0, visible = true, t0 = performance.now();
    hero.addEventListener('pointermove', (e) => { const r = canvas.getBoundingClientRect(); mx = e.clientX - r.left; my = e.clientY - r.top; }, { passive: true });
    hero.addEventListener('pointerleave', () => { mx = my = -9999; });
    window.addEventListener('scroll', () => { const y = window.scrollY; lift += clamp((y - lastY) * 6, -900, 900); lastY = y; }, { passive: true });
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(canvas);
    let last = performance.now();
    canvas.style.opacity = '0';
    requestAnimationFrame(() => { canvas.style.transition = 'opacity 1.2s ease'; canvas.style.opacity = '1'; });
    function frame(now) {
      requestAnimationFrame(frame);
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      if (!visible || document.hidden) return;
      const t = (now - t0) / 1000;
      lift *= Math.exp(-3 * dt);
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.clearRect(0, 0, W, H);
      for (const p of ps) {
        // deriva suave en diagonal + balanceo; el ratón aparta, el scroll levanta
        let wx = 38 + Math.sin(t * 0.7 + p.flip) * 26, wy = 24 + Math.cos(t * 0.9 + p.a) * 14 - lift * 0.35;
        const dx = p.x - mx, dy = p.y - my, d2 = dx * dx + dy * dy;
        if (d2 < 140 * 140) { const d = Math.sqrt(d2) || 1, f = (1 - d / 140) * 900; wx += (dx / d) * f; wy += (dy / d) * f; }
        const k = 1 - Math.exp(-p.drag * dt * 0.6);
        p.vx += (wx * p.z - p.vx) * k; p.vy += (wy * p.z - p.vy) * k;
        p.x += p.vx * dt; p.y += p.vy * dt;
        p.a += p.spin * dt * 0.35; p.flip += p.flipV * dt * 0.45;
        const m = 80;
        if (p.x > W + m) p.x = -m; if (p.x < -m * 1.5) p.x = W + m;
        if (p.y > H + m) p.y = -m; if (p.y < -m * 1.5) p.y = H + m;
        // en el propio lienzo del héroe: dprs ya aplicados por drawP con setTransform; se compensa aquí
        const c = Math.cos(p.a), si = Math.sin(p.a), fx = p.kind === 'p' ? Math.cos(p.flip) : 1;
        const set = p.kind === 'f' ? sp.flowers[p.i % sp.flowers.length] : sp.petals[p.i % sp.petals.length];
        const img = p.z > 1.2 ? set.soft : set.sharp;
        const s = p.size * p.z;
        g.globalAlpha = 0.5 + p.base;
        g.setTransform(c * fx * dpr, si * fx * dpr, -si * dpr, c * dpr, p.x * dpr, p.y * dpr);
        g.drawImage(img, -s / 2, -s / 2, s, s);
      }
      g.setTransform(1, 0, 0, 1, 0, 0); g.globalAlpha = 1;
    }
    requestAnimationFrame(frame);
  }

  // ---------- arranque
  if (window.__HDD_LYCORIS_DEBUG) { window.__hddLycoris = { makeSprites, flowerModel, petalModel, paint }; return; }
  // si el script llega muy tarde (móvil muy lento), la tienda ya está a la vista: no se tapa otra vez
  const late = !window.__HDD_LYCORIS_FIXED_DT && performance.now() > 6000;
  const playIntro = intro && doc.classList.contains('hs-intro-on') && !reduce && !late;
  if (!playIntro) {
    if (intro) intro.remove();
    doc.classList.remove('hs-intro-on');
    window.__hddIntroDone = true;
    window.dispatchEvent(new CustomEvent('hdd:intro-done'));
    if (hero && !reduce) {
      const go = () => ambient(makeSprites(false));
      'requestIdleCallback' in window ? requestIdleCallback(go, { timeout: 1500 }) : setTimeout(go, 400);
    }
    return;
  }
  try { sessionStorage.setItem('hdd-intro', '1'); } catch (e) { /* sin almacenamiento: se verá otra vez */ }
  const big = Math.min(window.innerWidth, window.innerHeight) > 700;
  const sp = makeSprites(big);
  storm(sp);
  window.addEventListener('hdd:intro-done', () => setTimeout(() => ambient(sp), 600), { once: true });
})();
